import ReactDOM from 'react-dom';
import './css/index.css';
import './css/bootstrap.min.css';
import Header from './Header';
import Footer from './Footer';
import { BrowserRouter,
  Routes,
  Route,
 } from "react-router-dom";
import Home from "./routes/home";
import Browse from "./routes/browse";
import Element from "./routes/element";
import AdvancedSearchPage from './routes/advanced';
import AllelicCuration from './routes/allelic-curation';
import Contact from './routes/contact';
import DownloadsPage from './routes/downloads';
import ManualPage from './routes/manual';
import ImageGalleryPage from './routes/gallery';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';



ReactDOM.render(
  
  <BrowserRouter basename='/vista'>
    <Header basename='vista'/>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="browse" element={<Browse />} />
      <Route path="element" element={<Element />} />  
      <Route path="advanced" element={<AdvancedSearchPage />} />
      <Route path="curation" element={<AllelicCuration />} />
      <Route path="downloads" element={<DownloadsPage />}/>
      <Route path="gallery" element={<ImageGalleryPage />}/>
      <Route path="manual" element={<ManualPage />} />
      <Route path="contact" element={<Contact />} />
    </Routes>
    <Footer/>
  </BrowserRouter>,
  
  document.getElementById('root')
  
);










